export default __webpack_public_path__ + "static/ssocase3-d21fa60a68106619b72df59e7d799dad.png";